export const CHECKWORK_WSPOS = 'check_work_wspos';
export const CHECKWORK_WSPOS_SUCCESSFUL = 'check_work_wspos_successfull';
export const CHECKWORK_WSPOS_FAILED = 'check_work_wspos_failed';



